import { gql } from '@apollo/client';

// Rows only: some articles embed megabytes of images, see GET_ARTICLE_DETAILS
export const GET_ARTICLES = gql`
  query GetArticles($input: ArticleFilterInput!) {
    getArticles(input: $input) {
      limit
      offset
      total
      entities {
        id
        title
        slug
        status
        type
        createdAt
        store {
          id
          slug
          storeDetails {
            storeName
          }
        }
        sourceInterviewee {
          id
          firstName
          lastName
          storeDetails {
            storeName
          }
        }
      }
    }
  }
`;

export const GET_ARTICLE_DETAILS = gql`
  query GetArticleDetails($input: ArticleFilterInput!) {
    getArticles(input: $input) {
      entities {
        id
        title
        slug
        status
        type
        createdAt
        content
        articleUrl
        imageLabel
        key
        url
        metaDescription
        keyTakeaways
        faq {
          question
          answer
        }
        hashtags {
          id
          name
        }
        mentions {
          id
          mentionType
          store {
            slug
            id
            storeDetails {
              storeName
              storeId
              avatarURL
            }
            firstName
            lastName
          }
          targetType
          unregisteredContact {
            email
            id
            name
            representativeName
            socialMediaLink
            type
            url
          }
        }
        store {
          id
          slug
          storeDetails {
            storeName
          }
        }
        sourceStream {
          id
          name
        }
        sourceInterviewer {
          id
          firstName
          lastName
          storeDetails {
            storeName
          }
        }
        sourceInterviewee {
          id
          firstName
          lastName
          storeDetails {
            storeName
          }
        }
      }
    }
  }
`;
